import {
    USER_DELETE_FRUI_PFXH_BEGIN,
    USER_DELETE_FRUI_PFXH_SUCCESS,
    USER_DELETE_FRUI_PFXH_FAILURE,
    USER_DELETE_FRUI_PFXH_DISMISS_ERROR,
  } from './constants';
  
  import request from '../../../utils/request'
  // Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
  // If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
  export function deleteFrui_pfxh(id) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: USER_DELETE_FRUI_PFXH_BEGIN,
      });
  
      // Return a promise so that you could control UI flow without states in the store.
      // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
      // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
      // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
      const promise = new Promise((resolve, reject) => {
          request({
            method:'delete',
            url:'/api/basic/gc/lng/' + id
          }).then( data => {
              dispatch({
                  type: USER_DELETE_FRUI_PFXH_SUCCESS,
              });
              resolve(data);
          }).catch (error => {
              dispatch({
                type: USER_DELETE_FRUI_PFXH_FAILURE,
                data: { error: error },
              });
              reject(error);
          })
      });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissDeleteFrui_pfxhError() {
    return {
      type: USER_DELETE_FRUI_PFXH_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case USER_DELETE_FRUI_PFXH_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          deleteFrui_pfxhPending: true,
          deleteFrui_pfxhError: null,
        };
  
      case USER_DELETE_FRUI_PFXH_SUCCESS:
        // The request is success
        return {
          ...state,
          deleteFrui_pfxhPending: false,
          deleteFrui_pfxhError: null,
        };
  
      case USER_DELETE_FRUI_PFXH_FAILURE:
        // The request is failed
        return {
          ...state,
          deleteFrui_pfxhPending: false,
          deleteFrui_pfxhError: action.data.error,
        };
  
      case USER_DELETE_FRUI_PFXH_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          deleteFrui_pfxhError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/user/redux/deleteFrui_pfxh.js